import React from "react";
import { useNavigate } from "react-router-dom";
import { RoutesLink } from "../../ApiHelper/RoutesLink";

const Forbidden403 = () => {
  const navigate = useNavigate();

  return (
      <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light text-center">
        <h1 className="display-1 fw-bold text-danger">403</h1>
        <p className="fs-3">
          🚫 <span className="text-danger">Access Denied</span>
        </p>
        <p className="lead">You do not have permission to view this page.</p>
        <button className="btn btn-outline-primary mt-3" type="button" onClick={() => navigate(RoutesLink?.login)}>
          Back to Dashboard
        </button>
      </div>
  );
};

export default Forbidden403;
